module.exports = __webpack_public_path__ + "img/电子目录logo.png";